import { env } from 'next-runtime-env';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const PHASE = env('NEXT_PUBLIC_PHASE');

const localApiUrls = {
  dev: 'https://bff-core-api-dev.vuddy.codes',
  sandbox: 'https://bff-core-api-sbx.vuddy.codes',
  production: 'https://core-api.vuddy.io',
  'internal-production': 'https://core-api.vuddy.io',
} as const;

const localMediaApiUrls = {
  dev: 'https://media-dev.vuddy.codes',
  sandbox: 'https://media-dev.vuddy.codes',
  production: 'https://media.vuddy.io',
  'internal-production': 'https://media.vuddy.io',
} as const;

export const API_URL = IS_PRODUCTION
  ? env('NEXT_PUBLIC_API_URL')
  : localApiUrls[PHASE];

export const MEDIA_API_URL = IS_PRODUCTION
  ? env('NEXT_PUBLIC_MEDIA_API_URL')
  : localMediaApiUrls[PHASE];
